import PropTypes from "prop-types";
import {ButtonPill} from "@/base";
import {useState} from "react";
import SwatchesWidget from "@/pages/products/detailWidgets/SwatchesWidget";
import {em} from "@util/convertUnits";
import {css, useTheme} from "@emotion/react";

const SwatchesTabsWidget = ({ tabs }) => {

    const [activeTab, setActiveTab] = useState(0);
    const theme = useTheme();

    let tabCss = css(`

            margin-bottom: 10px;
            text-align: right;
            &:nth-of-type(even){
                text-align: left;
            }
            
            @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
                width: auto;
                text-align: unset;
            }
            
            > button{
                height: 100%;
            }
        `)

    const buttons = () => {

        return tabs?.map((tab, tabIndex)=>{
            if(tab.hide) return null;
            return <span key={tab.label} className={'px-1'} css={tabCss}>
                <ButtonPill buttonTheme={'light-grey'} active={activeTab === tabIndex}
                            onClick={()=>setActiveTab(tabIndex)}>{tab.label}</ButtonPill>
            </span>
        })
    }

    const swatches = () => {
        return tabs?.[activeTab] && (
            <div key={tabs[activeTab].key}>
                <SwatchesWidget content={tabs[activeTab]}/>
            </div>
        )
    }

    return (
        <div>
            {tabs?.length > 1 && <div className={'d-flex flex-row flex-wrap justify-content-center py-1'}>{buttons()}</div>}
            {swatches()}
        </div>
    )
}

SwatchesTabsWidget.propTypes = {
    tabs: PropTypes.array
};
export default SwatchesTabsWidget;